import * as events from 'GladlySidekickConstants';

export default class ApiObserver {
  constructor() {
    this.observers = {};
    this.observers[events.CUSTOMER_ONBOARDED_EVENT] = [];
    this.observers[events.MESSAGE_SENT_EVENT] = [];
    this.observers[events.MESSAGE_RECEIVED_EVENT] = [];
    this.observers[events.SEARCH_RESULT_SELECTED] = [];
    this.observers[events.SESSION_ENDED_EVENT] = [];
    this.observers[events.SESSION_STARTED_EVENT] = [];
    this.observers[events.WIDGET_OPENED_EVENT] = [];
    this.observers[events.WIDGET_CLOSED_EVENT] = [];
    this.observers[events.QUICK_ACTION_SELECTED] = [];
    this.observers[events.AVAILABILITY_CHANGE_EVENT] = [];
  }

  isValidEventName(eventName) {
    return !!this.observers[eventName];
  }

  addObserver(eventName, func) {
    if (!this.isValidEventName(eventName)) {
      throw new Error('invalid eventName: ' + eventName);
    }
    this.observers[eventName].push(func);
  }

  getObservers(eventName) {
    return this.observers[eventName];
  }

  removeObservers(eventName, func) {
    this.observers[eventName] = this.observers[eventName].filter(function(fn) {
      return fn != func;
    });
  }
}
